import { __rest } from "tslib";
import * as React from 'react';
const PlayFillSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M6 4.924v10.152c0 .72.777 1.163 1.383.787l8.182-5.075a.93.93 0 0 0 0-1.575L7.383 4.137C6.777 3.76 6 4.203 6 4.924Z" })));
};
PlayFillSmall.displayName = 'PlayFillSmall';
export default PlayFillSmall;
//# sourceMappingURL=PlayFillSmall.js.map